import { Controller } from '@hotwired/stimulus';

/**
 * This controller cycles through its item targets, meaning: One of the targets is thought of as
 * 'active', all the other ones as 'inactive'. The index of the active target is stored in the state
 * value.
 *
 * If a target becomes active, the controller dispatches an 'active' event on it. If a target
 * becomes inactive, the controller dispatches an 'inactive' event on it.
 *
 * These events are also dispatched on the indicator targets with the corresponding indices. You
 * can ignore this second set of targets if you don't need them.
 */

// Connects to data-controller="cycle"
export default class extends Controller {
  static targets = ['item', 'indicator'];
  static values = {
    state: Number,
  };

  connect() {}

  next() {
    this.stateValue++;
  }

  previous() {
    this.stateValue--;
  }

  set(event) {
    this.stateValue = event.params['state'];
  }

  stateValueChanged(current, previous) {
    this.notifyTargets(this.itemTargets, current, previous);
    this.notifyTargets(this.indicatorTargets, current, previous);
  }

  notifyTargets(targets, currentIndex, previousIndex) {
    this.dispatch('inactive', { target: targets[previousIndex] });
    this.dispatch('active', { target: targets[currentIndex] });
  }
}
